import Image from 'next/image';
import { useRouter } from 'next/router';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { type FC, useCallback, useEffect } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useRubikaUser, useShadUser } from '@/Module/Auth/Hook';
import { DAY, FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { hasHappened } from '@/Module/Core/Helper';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { useCampaign } from '@/Module/DefaultLayout/Hook';
interface BrowserCheckSnackbarContentProps {
  deviceType: DeviceType;
  handleCloseClick: () => void;
}
const STORAGE_KEY = 'browser_check_prompt_dismissed';
const BrowserCheckSnackbarContent: FC<BrowserCheckSnackbarContentProps> = ({
  deviceType,
  handleCloseClick
}) => <div className={`flex flex-row items-center gap-4 text-justify ${deviceType === DeviceType.MOBILE ? 'w-[86vw]' : 'w-[100vw]'}`} data-sentry-component="BrowserCheckSnackbarContent" data-sentry-source-file="index.tsx">
    <Image className="h-[40px] w-[40px]" src={`${FILE_BROWSER_URL}/img/ino.webp`} alt="App Icon" width="40" height="40" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    <span className="font-bold">
      <span>برای استفاده بهینه از آی‌نو، توصیه می‌شود از مرورگر مبتنی بر</span>
      <span> </span>
      <span className="text-red-600">Chrome</span>
      <span> </span>
      <span>استفاده کنید.</span>
    </span>
    <Button className="!h-1 w-1 rounded-full border-[10px] border-red-600 pb-[1px]" variant="text" color="white" bold onClick={handleCloseClick} data-sentry-element="Button" data-sentry-source-file="index.tsx">
      x
    </Button>
  </div>;
const BrowserCheck = () => {
  const router = useRouter();
  const {
    bannerEnabled
  } = useCampaign();
  const isShadUser = useShadUser();
  const isRubikaUser = useRubikaUser();
  const deviceType = useDeviceType();
  const rubikaToken = router.query?.ut;
  const shadToken = router.query?.UserID;
  const handleCloseClick = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    closeSnackbar();
  }, []);
  const showInstallPrompt = useCallback(() => {
    enqueueSnackbar(<BrowserCheckSnackbarContent deviceType={deviceType} handleCloseClick={handleCloseClick} />, {
      variant: 'default',
      persist: true,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      style: {
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '8px',
        padding: `${deviceType === DeviceType.MOBILE ? '2px 16px' : '0px 16px'}`,
        position: 'fixed',
        top: bannerEnabled ? '70px' : `${deviceType === DeviceType.MOBILE ? '50px' : '70px'}`,
        left: '1%',
        right: `${deviceType === DeviceType.MOBILE ? '0%' : '-60%'}`,
        width: `${deviceType === DeviceType.MOBILE ? '100%' : '222%'}`,
        zIndex: 9999
      }
    });
  }, [deviceType, handleCloseClick, bannerEnabled]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (hasHappened(STORAGE_KEY, DAY, 1) || isShadUser || isRubikaUser || rubikaToken || shadToken) return;
      const ua = window.navigator.userAgent;
      const isChrome = ua.includes('Chrome') || ua.includes('CriOS');
      if (!isChrome) {
        showInstallPrompt();
      }
    }
  }, []);
  return null;
};
export default BrowserCheck;